<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData>0" />
                <div v-else>
                    <h4 class="text-error mb-2.5 font-normal">
                        您目前保單紅利/增值回饋分享金給付方式為 {{ userInfo.payMethodText }}
                    </h4>
                    <div class="border-t border-gray-100 text-base mb-7 py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲變更之給付方式
                        </h4>
                        <Radio
                            v-for="(item,index) in payMethodList"
                            :key="index"
                            v-model:checkedValue="selected"
                            :value="item.value"
                            :text="item.text"
                            :disabled="userInfo.payMethod===item.value || !item.enable"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="selected===''||selected===userInfo.payMethod||isGettingData>0"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoB2, submitB2 } from '@/apis/B2';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import Skeletons from '@/components/skeletons/Skeletons.vue';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const isSubmitOk = ref(false);
        const isLoading = ref(false);
        const isGettingData = ref(0);
        const selected = ref('');
        const payMethodList = ref([]);
        const userInfo = ref({
            payMethod: '',
            payMethodText: '',
        });

        const result = computed(() => store.state.services.changeItemsResult[code]);

        // 取得api資料
        const getData = () => {
            isGettingData.value = 1;
            getInfoB2().then(res => {
                userInfo.value.payMethod = res.data.dividendKind;
                userInfo.value.payMethodText = res.data.dividendKindText;
                selected.value = userInfo.value.payMethod;
                payMethodList.value = res.data.options.map(i => {
                    i.value = i.dividendKind;
                    i.text = i.dividendKindText;
                    return i;
                });
            }).finally(() => {
                isGettingData.value -= 1;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const { storeUserInfo, storeList, selectVal } = result.value;
            selected.value = selectVal;
            userInfo.value = storeUserInfo;
            payMethodList.value = storeList;
        }

        const saveAndgoNext = () => {
            isLoading.value = true;
            const returnData = {
                dividendKind: selected.value,
            };
            submitB2(returnData).then(res => {
                isSubmitOk.value = true;
                const value = {
                    storeList: payMethodList.value,
                    storeUserInfo: userInfo.value,
                    selectVal: selected.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return {
            selected,
            payMethodList,
            userInfo,
            isLoading,
            isGettingData,
            saveAndgoNext,
            isSubmitOk
        };
    },
};
</script>
